import { createFileRoute } from "@tanstack/react-router";
import Cars from "@/pages/Cars";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/cars/")({
  head: () => routeHead("/uk/cars/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Cars />
  );
}
